import { RedoOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { Button, Popover, Modal, Input } from 'antd';
import CountUp from 'react-countup';
import axios from 'axios';
import config from '../../config';
import VenteClientDetail from './venteClientDetail/VenteClientDetail';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Ticket from './ticket/Ticket';
import VenteView from './venteView/VenteView';
import canSeeFinance from '../../utils/canSeeFinance';
import {
  NdoeToolbar, NdoeActionButton, NdoeResponsiveTable,
  NdoeStats, NdoeStatCard, useIsDesktop,
} from '../../components/ndoe';
import { buildVenteColumns, buildVenteCardRenderer, venteSearchFilter } from './venteShared';

// Onglet « Ventes du jour » — même liste que l'onglet « Ventes » (colonnes et
// cartes partagées via venteShared.jsx), restreinte à aujourd'hui. Refondu au
// design system : cartes sur mobile au lieu du tableau compressé, refetch ciblé
// au lieu du window.location.reload qui perdait la recherche.
const VentesJour = () => {
    const DOMAIN = config.REACT_APP_SERVER_DOMAIN;
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const [open, setOpen] = useState(false);
    const [idClient, setIdClient] = useState({});
    const [ticket, setTicket] = useState(false);
    const [idTicket, setIdTicket] = useState(false);
    const user = useSelector((state) => state.user?.currentUser);
    const [openVente, setOpenVente] = useState(false);
    const [iDcommande, setIdCommande] = useState('');
    const [recent, setRecent] = useState([]);
    const isDesktop = useIsDesktop();

    const fetchVentes = async () => {
      setLoading(true);
      try {
        const { data } = await axios.get(`${DOMAIN}/api/vente/venteDuJour`);
        setData(data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
      try {
        const { data } = await axios.get(`${DOMAIN}/api/rapport/rapport/venteRecentJour`);
        setRecent(data);
      } catch (error) {
        console.log(error);
      }
    };

    useEffect(() => {
      fetchVentes();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [DOMAIN]);

    const handleDelete = async (id) => {
      try {
        await axios.delete(`${DOMAIN}/api/vente/${id}`);
        fetchVentes();
        toast.success('Vente supprimée');
      } catch (err) {
        toast.error("Échec de la suppression de la vente");
      }
    };

    const HandVenteOpen = (e) => {
      setOpenVente(!openVente);
      setIdCommande(e)
    };

    const handleOk = async (e) => {
      setOpen(true)
      setIdClient(e)
    };

    const handleTicket = async (e) => {
      setTicket(true)
      setIdTicket(e)
    };

  const columns = buildVenteColumns({
    user,
    onOpenClient: handleOk,
    onOpenVente: HandVenteOpen,
    onTicket: handleTicket,
    onDelete: handleDelete,
  });
  const renderVenteCard = buildVenteCardRenderer({
    user,
    canFinance: canSeeFinance(user),
    onOpenVente: HandVenteOpen,
    onTicket: handleTicket,
    onDelete: handleDelete,
  });

  const filteredData = data?.filter(venteSearchFilter(searchValue));

  return (
    <>
      <NdoeStats>
        <NdoeStatCard label="Articles vendus (jour)" value={<CountUp end={recent[0]?.nbre_article_vendue || 0} />} />
        <NdoeStatCard label="Client(e)s acheteur(s)" value={<CountUp end={recent[0]?.nbre_de_vente || 0} />} />
        <NdoeStatCard label="Commandes" value={<CountUp end={recent[0]?.nbre_commande || 0} />} />
        {canSeeFinance(user) && (
          <NdoeStatCard gold label="Montant (jour)" value={<><CountUp end={recent[0]?.montant_total || 0} /> $</>} />
        )}
      </NdoeStats>

      <NdoeToolbar
        search={
          <Input.Search
            type="search"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            placeholder="Recherche (client, article, livreur)…"
            allowClear
          />
        }
      >
        <Popover content={'Actualiser cette liste'}>
          <NdoeActionButton variant="ghost" icon={<RedoOutlined />} onClick={fetchVentes}>
            Actualiser
          </NdoeActionButton>
        </Popover>
      </NdoeToolbar>

      <NdoeResponsiveTable
        data={filteredData}
        columns={columns.filter((col) => col.key !== 'total_prix_vente' || canSeeFinance(user))}
        rowKey={(record, i) => record.id_vente ?? record.id_commande ?? i}
        loading={loading}
        scroll={{ x: 'max-content' }}
        pagination={isDesktop ? { pageSize: 10 } : false}
        renderCard={renderVenteCard}
        empty={{ icon: '🧾', title: 'Aucune vente aujourd\'hui', text: 'Les ventes confirmées du jour apparaîtront ici.' }}
      />

      {/* Modales */}
      <Modal
        title="Information du client"
        centered
        open={open}
        onCancel={() => setOpen(false)}
        width={850}
        footer={[
          <Button key="annuler" onClick={() => setOpen(false)}>
            Annuler
          </Button>
        ]}
      >
        <VenteClientDetail idClients={idClient}/>
      </Modal>

      <Modal
        title="Ticket"
        centered
        open={ticket}
        onCancel={() => setTicket(false)}
        width={550}
        footer={[]}
      >
        <Ticket idTicket={idTicket}/>
      </Modal>

      <Modal
        title=""
        centered
        open={openVente}
        onCancel={() => setOpenVente(false)}
        width={1150}
        footer={[]}
      >
        <VenteView id={iDcommande}/>
      </Modal>
    </>
  )
}

export default VentesJour
